<article
  class="snackbar-item"
  [attr.data-variant]="message.variant"
  role="status"
  aria-live="polite"
>
  <div class="snackbar-item__media">
    @if (message.imageUrl) {
      <img
        class="snackbar-item__image"
        [src]="message.imageUrl"
        [alt]="message.title"
      />
    } @else {
      <span class="snackbar-item__fallback" aria-hidden="true">N</span>
    }
  </div>

  <div class="snackbar-item__content">
    <strong class="snackbar-item__title">{{ message.title }}</strong>
    <p class="snackbar-item__description">{{ message.description }}</p>
  </div>

  @if (message.dismissible) {
    <button
      type="button"
      class="snackbar-item__dismiss"
      (click)="dismiss()"
      aria-label="Dispensar notificação"
    >
      ×
    </button>
  }
</article>
